import React from "react"

export const LowerHeaderWrapper = ({children}) => {
    return (
        <div data-testid="header-lowerheader" id="platform_modernisation_meganav">
            {children}
        </div>
    )
}

export default LowerHeaderWrapper
